export default {
    name: 'regions',
    serverName: '/api/v1/region/region/',
    apiUrl: '/api/v1/region/region/'
};
